<h1 mat-dialog-title class="text-center pm-dialog-title">
    {{ this.title }}
</h1>
<div mat-dialog-content class="content">
    <div class="row mb-2" *ngFor="let item of serialBatchNoCriteria">
        <div class="col-4">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                <input type="text" matInput 
                [(ngModel)]="item.text"
                name="stringText" placeholder="Text">
            </mat-form-field>
        </div>
        <div class="col-4">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                <mat-select placeholder="Type" [(ngModel)]="item.type" 
                    (selectionChange)="item.type == 'string' ? 
                    item.operation = '' : item.operation">
                  <mat-option value="number">Number</mat-option>
                  <mat-option value="string">String</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-4">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                <mat-select placeholder="Operation" 
                    [(ngModel)]="item.operation" 
                    [disabled]="item.type == 'string' || item.type == '' ">
                  <mat-option value="+">Increment</mat-option>
                  <mat-option value="-">Decrement</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="initAutoStringCreation()">{{'Language.OkText' | translate}}  </button>
    <button mat-raised-button mat-dialog-close>{{'Language.CancelText' | translate}}  </button>
</div>